import { render, staticRenderFns } from "./trigger-event.vue?vue&type=template&id=6ef1117a&scoped=true"
import script from "./trigger-event.vue?vue&type=script&lang=js"
export * from "./trigger-event.vue?vue&type=script&lang=js"
import style0 from "./trigger-event.vue?vue&type=style&index=0&id=6ef1117a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1117a",
  null
  
)

export default component.exports